import { timestampDate, type Timestamp } from "@bufbuild/protobuf/wkt";
import type { Poll } from "#gen/forms/v1/poll_pb.js";
import type { JsonObject, JsonValue } from "#lib/protobuf-compat.js";

export function isEndBeforeOrAtStart(start: Timestamp | undefined, end: Timestamp | undefined): boolean {
	return Boolean(start && end && timestampDate(end).getTime() <= timestampDate(start).getTime());
}

export function setEditorState(editorState: Record<string, unknown>, poll: Poll, key: string, value: JsonValue) {
	const state: JsonObject = (editorState[poll.id] as JsonObject) ?? {};
	if (value === null || value === undefined) {
		delete state[key];
		return { ...editorState, [poll.id]: { ...state } };
	}
	return { ...editorState, [poll.id]: { ...state, [key]: value } };
}

export function resetEditorState(editorState: Record<string, unknown>, poll: Poll) {
	return { ...editorState, [poll.id]: { overrideSelection: undefined, overridePollState: undefined } };
}
